export default {
   intro: '',
   info: `[[ p ]]
      Gerne stellen wir Ihnen ein Gruppenangebot nach Ihren Wünschen zusammen.
      [[ {"a":{"href":"https://www.jugendfarm-er.de", "title":"Sehen Sie sich unsere Gruppenangebote an.", "target":"_blank"}} ]]Informieren Sie sich hier über unsere Angebotspalette[[ /a ]]
      und teilen Sie uns nachfolgend mit, für welche Inhalte Sie sich interessieren. Abgestimmt auf
      das Alter und die Anzahl der Kinder senden wir Ihnen dann ein individuell zugeschnittenes
      Angebot mit Kostenaufstellung zu.
      [[ /p ]]`,
   footer: '[[ {"a":{"href":"https://jugendfarm-er.de", "title":"Impressum und Datenschutz ansehen", "target":"_blank"}} ]]Impressum / Datenschutz[[ /a ]]',
   approvals: [
      'Ich habe die besonderen [[ {"a":{"href":"https://www.jugendfarm-er.de", "title":"Nutzungsbedingungen der Jugendfarm Erlangen als PDF ansehen", "target":"_blank"}} ]]Hinweise und Nutzungsbedingungen[[ /a ]] der Jugendfarm gelesen und erkenne sie an.',
      'Ich stimme der Verarbeitung und Speicherung meiner Daten im Rahmen des [[ {"a":{"href":"https://www.jugendfarm-er.de", "title":"Datenschutz der Jugendfarm Erlangen als PDF ansehen", "target":"_blank"}} ]]Datenschutzes[[ /a ]] zu.'
   ],
   approvalSepa: [
      'Ich ermächtige die Jugendfarm e.V. eine einmalige Zahlung von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von der Jugendfarm e.V. auf mein Konto gezogene Lastschrift einzulösen.'
   ]
};